export default {
  lastUrl: null,
  patientPrivacyUrl: null,
  patientPrivacyUrlLabel: null,
  sidenavLinks: null
}



//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/store/modules/website/state.js
// module id = null
// module chunks = 